import React, { useEffect, useState } from 'react'
import '../AirportMaster/AirportMaster.css'
import './AirlineMaster.css'
import { fetchAirlineList } from '../../Api/Airline'
import { AddUpdateAirline } from '../../Api/Airline'
import { deleteAirline } from '../../Api/Airline'
import Swal from 'sweetalert2'

const AirlineMaster = () => {

    // Add Airline Form 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAirlineForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // Add/Update Airline API Function 
    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            Id: airlineForm.Id,
            AirlineCode: airlineForm.AirlineCode,
            AirlineName: airlineForm.AirlineName,
        };

        try {
            await AddUpdateAirline(payload)
            
                .then(response => {
                    console.log(response)
                    
                    if (response?.Status === 200) {
                        Swal.fire({
                            title: "Success!",
                            text: isEdit ? "Airline updated successfully!" : "Airline added successfully!",
                            icon: "success",
                            confirmButtonText: "OK"
                        }).then(() => {
                            window.location.reload();
                        });

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response?.Data || "Something went wrong",
                            icon: "error",
                            confirmButtonText: "OK"
                        });
                    }
                })
                .catch(error => {
                    console.error("Add Airline error: ", error);
                    Swal.fire({
                        title: "Error!",
                        text: isEdit ? "Failed to update airline" : "Failed to add airline",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                });

            setAirlineForm({
                AirlineCode: "",
                AirlineName: "",
            });

        } catch (error) {
            console.error("Add Airline failed", error);
        }
    };

    const [airlineForm, setAirlineForm] = useState({
        Id: 0,
        AirlineCode: "",
        AirlineName: "",
    });

    // State for airline list
    const [airlineListRequest, setAirlineListRequest] = useState({
        PageNo: 1,
        PageSize: 50,
        SortBy: "",
        AirlineName: "",
        AirlineCode: ""
    });

    const [airlineList, setAirlineList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        fetchAirlineList(airlineListRequest)
            .then(response => {
                setAirlineList(response.Data || []);
            })
            .catch(error => {
                console.error("Error fetching airline list:", error);
            });
    }, [airlineListRequest]);

    const handleNext = () => {
        setAirlineListRequest(prev => ({
            ...prev,
            PageNo: prev.PageNo + 1
        }));
    };

    const handlePrev = () => {
        setAirlineListRequest(prev => ({
            ...prev,
            PageNo: Math.max(prev.PageNo - 1, 1)
        }));
    };

    const handleDelete = async (airlineId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteAirline(airlineId)
                        .then(response => {
                            if (response?.Status === 200) {
                                Swal.fire({
                                    title: "Deleted!",
                                    text: "Airline deleted successfully!",
                                    icon: "success",
                                    confirmButtonText: "OK"
                                }).then(() => {
                                    window.location.reload();
                                });
                            } else {
                                Swal.fire({
                                    title: "Error!",
                                    text: response?.Message || "Failed to delete airline.",
                                    icon: "error",
                                    confirmButtonText: "OK"
                                });
                            }
                        })
                        .catch(error => {
                            console.error("Delete Airline error: ", error);
                            Swal.fire({
                                title: "Error!",
                                text: "Failed to delete airline",
                                icon: "error",
                                confirmButtonText: "OK"
                            });
                        });

                    setAirlineForm({
                        AirlineCode: "",
                        AirlineName: "",
                    });
                } catch (error) {
                    console.error("Delete Airline failed", error);
                }
            }
        });
    };

    return (
        <>
            {/* Airline Add/Edit Form */}
            {showForm &&
                <div className="container-fluid bg-white p-4 border mb-4" style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.10)", borderRadius: "16px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6 className="section-1-title mb-0 text-start">
                            {isEdit ? "Update Airline" : "Add Airline"}
                        </h6>
                        <button
                            type="button"
                            className="btn"
                            onClick={() => setShowForm(false)}
                            title="Close"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Airline Code"
                                    name="AirlineCode"
                                    value={airlineForm.AirlineCode}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Airline Name"
                                    name="AirlineName"
                                    value={airlineForm.AirlineName}
                                    onChange={handleChange}
                                />
                            </div>
                            {/* <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Country"
                                    name="Country"
                                    value={airlineForm.Country}
                                    onChange={handleChange}
                                />
                            </div> */}
                            <div className="col-12 mt-3 text-start">
                                <button type="submit" className="Save-btn">
                                    {isEdit ? "Update Airline" : "Save"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            }

            {/* Airline List/Table */}
            <div className="bg-white" style={{ borderRadius: '16px', boxShadow: "0 2px 8px rgba(0,0,0,0.10)" }}>
                {/* Section Header */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center p-4 gap-2">
                    {/* Title */}
                    <div className="section-1-title align-self-start">
                        Airline List
                    </div>

                    {/* Header Buttons */}
                    <div className="d-flex flex-row flex-sm-col gap-2 gap-sm-1 section-header-buttons w-sm-auto">
                        <div className="d-flex gap-2">
                            {/* Filter */}
                            {/* <button className="btn btn-light rounded-circle d-flex align-items-center justify-content-center circular-btn">
                                <img src="./assest/Images/filter.png" alt="Filter" />
                            </button> */}
                        </div>
                        <button
                            className="ms-auto create-new-btn p-2 rounded-5"
                            onClick={() => setShowForm(prev => !prev)}
                        >
                            {showForm ? "✖ Close" : "+ Create New"}
                        </button>
                    </div>
                </div>

                {/* Search */}
                <div className="px-4 pb-3">
                    <input
                        className="search-bar rounded-3"
                        type="search"
                        placeholder="Search Airline"
                    />
                </div>

                {/* Airline Table */}
                <div className="px-3 pb-4 table-responsive custom-scroll">
                    <table className="table p-2 table-borderless data-table">
                        <thead style={{ 
                fontFamily: "Poppins", 
                backgroundColor: "#F8F9FF",     
                borderWidth: "1px 0px 1px 0px",
                borderStyle: "solid",
                borderColor: "#0000001A",   

              }}>
                            <tr>
                                <th className="table-field-bg-color" style={{paddingLeft:"25px"}}>S. No.</th>
                                <th className="table-field-bg-color">Airline Code</th>
                                <th className="table-field-bg-color airline-name-col">Airline Name</th>
                                <th className="table-field-bg-color text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody style={{ overflow: "scroll",textAlign:"left" }}>
                            {airlineList.items && airlineList.items.length > 0 ? (
                                airlineList.items.map((airline) => (
                                    <tr key={airline.Id} style={{height:"10px",borderBottom: "1px solid #0000001A", verticalAlign:"middle"}}>
                                        <td style={{paddingLeft:"25px"}}>{airline.rno}</td>
                                        <td>{airline.AirlineCode}</td>
                                        <td className='airline-name-col'>{airline.AirlineName}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn bg-light btn-sm me-2"
                                                title="Edit"
                                                onClick={() => {
                                                    setShowForm(true);
                                                    setIsEdit(true);
                                                    setAirlineForm({
                                                        Id: airline.Id,
                                                        AirlineCode: airline.AirlineCode,
                                                        AirlineName: airline.AirlineName,
                                                    });
                                                }}
                                            >
                                                <img src="./assest/Images/Edit.png" alt="Edit" style={{ width: "1rem" }} />
                                            </button>
                                            <button
                                                className="btn bg-light btn-sm"
                                                title="Delete"
                                                onClick={() => handleDelete(airline.Id)}
                                            >
                                                <img src="./assest/Images/delete.png" alt="Delete" style={{ width: "1rem" }} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center">No airlines found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center px-4 py-3">
            <span>
                Page {Math.min(airlineList.metaData?.currentPage || airlineListRequest.PageNo, airlineList.metaData?.totalPages || 1)} of {airlineList.metaData?.totalPages || 1}
            </span>
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-light btn-sm"
                        onClick={handlePrev}
                        disabled={airlineListRequest.PageNo === 1}
                    >
                        Prev
                    </button>
                    <button
                        className="btn btn-light btn-sm"
                        onClick={handleNext}
                        disabled={
                            (airlineList.metaData?.currentPage || airlineListRequest.PageNo)
                            ===
                            (airlineList.metaData?.totalPages || 1)
                        }
                    >
                        Next    
                    </button>
                </div>
            </div>
        </>
    )
}

export default AirlineMaster